<template>
  <ion-page class="bg-white">
    <ion-content class="welcome-wrapper bg-white">
      <LargeNavbar
        show-back-button
        @back-button="onBackButton"
        :show-actions="false"
        :title="'Notifications'"
      />
      <div class="w-100 bg-white d-flex justify-space-center min-h100">
        <div class="simple-content content w-100 h-100">
          <div class="d-flex justify-space-between">
            <div class="d-flex">
              <ion-chip
                @click="changeStatus(false)"
                color="grey"
                :class="!isRead ? 'active-grey' : ''"
                :outline="true"
              >
                <ion-label>Not read </ion-label>
              </ion-chip>
              <ion-chip
                @click="changeStatus(true)"
                :class="isRead ? 'active-grey' : ''"
                color="grey"
                :outline="true"
              >
                <ion-label>All </ion-label>
              </ion-chip>
            </div>

            <ion-chip @click="markAsRead()" color="primary" class="active" :outline="true">
              <ion-label>Mark as read </ion-label>
            </ion-chip>
          </div>

          <div v-if="notificationsInPage.length > 0" class="mt-xs">
            <div class="ba-grey border-default">
              <div v-for="notification in notificationsInPage" :key="`notif-list-${notification.id}`">
                <NotificationCard
                  :title="notification.title"
                  :created-at="notification.createdAt"
                  :is-read="notification.isRead"
                  :type="notification.type"
                  @click-notification="
                    handleClickNotification(
                      notification.id,
                      notification.type,
                      notification.extraData?.actionId as string,
                    )
                  "
                />
              </div>
            </div>
          </div>
          <div v-else-if="!isLoading" class="d-flex justify-space-center w-100 pa-xs">
            Nothing to read
          </div>

          <div v-if="notificationsInPage.length > 0 && pagination.pages > pagination.page">
            <ion-infinite-scroll @ionInfinite="ionInfinite">
              <div class="gap-xs d-flex flex-column pt-xs">
                <div v-for="(_, idx) in 9" :key="`skeleton-notif-${idx}`"><SkeletonListItemCard :width="'100%'" /></div></div
            ></ion-infinite-scroll>
          </div>

          <div v-if="isLoading">
            <div class="gap-xs d-flex flex-column mt-xs">
              <div v-for="(_, idx) in 9" :key="`skeleton-notif-${idx}`"><SkeletonListItemCard :width="'100%'" /></div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>
<script setup lang="ts">
  import { ref } from 'vue';
  import router from '@/router';
  import {
    IonContent,
    IonPage,
    IonChip,
    IonLabel,
    InfiniteScrollCustomEvent,
    IonInfiniteScroll,
  } from '@ionic/vue';
  import LargeNavbar from '@/components/LargeNavbar.vue';
  import NotificationCard from '@/components/notifications/NotificationCard.vue';
  import { storeToRefs } from 'pinia';
  import { useNotificationsStore } from '@/stores/notifications-store';
  import { useToast } from '@/composables/useToast';
  import { useNotifications } from '@/composables/useNotifications';
  import SkeletonListItemCard from '@/components/loaders/SkeletonListItemCard.vue';

  const { isRead, notificationsInPage, pagination } = storeToRefs(useNotificationsStore());
  const { markAllAsRead } = useNotificationsStore();
  const { handleGetNotifications, handleClickNotification } = useNotifications();
  const { showToast } = useToast();
  const isLoading = ref(false);

  const onBackButton = () => {
    router.back();
  };

  const ionInfinite = (ev: InfiniteScrollCustomEvent) => {
    handleGetNotifications(pagination.value.page + 1);
    setTimeout(() => ev.target.complete(), 500);
  };

  const markAsRead = async () => {
    try {
      isLoading.value = true;
      await markAllAsRead();
      await handleGetNotifications();
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      isLoading.value = false;
    }
  };

  const changeStatus = async (status: boolean) => {
    if (status !== isRead.value) {
      isRead.value = status;

      isLoading.value = true;
      await handleGetNotifications();
      isLoading.value = false;
    }
  };
</script>

<style lang="css" scoped>
  .simple-content {
    padding: 12px;
    height: 100%;
  }
  .min-h100 {
    min-height: 90vh;
  }
</style>
